import dayjs from "dayjs"
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'undefined' || time === null || time === 'null') {
    return ''
  } else if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (time == null) return '----'

  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function formatTimeTwo(time) {
  if (time == null) return '无'
  // time = time * 1000
  const d = new Date(time)
  return (
    d.getFullYear() + '年' +
    (d.getMonth() + 1) +
    '月' +
    d.getDate() +
    '日' +
    d.getHours() +
    '时' +
    d.getMinutes() +
    '分'
  )
}
export function formatTimeThree(time) {
  time = time * 1000
  const d = new Date(time)
  return (
    d.getFullYear() + '年' +
    (d.getMonth() + 1) +
    '月' +
    d.getDate() +
    '日' +
    d.getHours() +
    '时' +
    d.getMinutes() +
    '分'
  )
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 替换邮箱字符
export function regEmail(email) {
  if (String(email).indexOf('@') > 0) {
    const str = email.split('@')
    let _s = ''
    if (str[0].length > 3) {
      for (var i = 0; i < str[0].length - 3; i++) {
        _s += '*'
      }
    }
    var new_email = str[0].substr(0, 3) + _s + '@' + str[1]
  }
  return new_email
}

// 替换手机字符
export function regMobile(mobile) {
  var new_mobile = '';
  if (mobile && mobile.length > 7) {
    new_mobile = mobile.substr(0, 3) + '****' + mobile.substr(7)
  }
  return new_mobile
}

// 下载文件
export function downloadFile(obj, name, suffix) {
  const url = window.URL.createObjectURL(new Blob([obj]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  const fileName = name + dayjs().format('YYYYMMDDhhmmss') + '.' + suffix
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function RandomNumber() {
  var min = 5; var max = 36
  var randomStr = ''
  var range = (max ? Math.round(Math.random() * (max - min)) + min : min)
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

  for (var i = 0; i < range; i++) {
    var index = Math.round(Math.random() * (arr.length - 1))
    randomStr += arr[index]
  }
  return randomStr
}

export function copyPlate(carPlate) {
  // TODO: navigator.clipboard.writeText 只支持 https 安全模式下
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard 向剪贴板写文本
    this.$message.success('复制成功,车牌:' + carPlate)
    return navigator.clipboard.writeText(carPlate)
  } else {
    const ele = document.createElement('input') // 创建一个input标签
    ele.setAttribute('value', carPlate) // 设置改input的value值
    document.body.appendChild(ele) // 将input添加到body
    ele.select() // 获取input的文本内容
    document.execCommand('copy') // 执行copy指令
    document.body.removeChild(ele) // 删除input标签

    return this.$message.success('复制成功,车牌:' + carPlate)
  }
}

/**
 * 美化车牌
 * @param plateColorType 5: 蓝牌; 4: 黑牌; 3: 绿牌; 2: 黄牌; 1: 白牌;
 * @returns {string}
 */
export function licencePlateColor(plateColorType) {
  let classColorVal = 'blue'
  if (plateColorType == 4 || plateColorType == '黑牌' || plateColorType == '黑色') {
    classColorVal = 'black'
  } else if (plateColorType == 3 || plateColorType == '绿牌' || plateColorType == '绿色') {
    classColorVal = 'green'
  } else if (plateColorType == 2 || plateColorType == '黄牌' || plateColorType == '黄色') {
    classColorVal = 'yellow'
  } else if (plateColorType == 1 || plateColorType == '白牌' || plateColorType == '白色') {
    classColorVal = 'white'
  } else {
    classColorVal = 'blue'
  }
  return 'plate-' + classColorVal
}

/**
 * 格式化车牌
 * @param source
 * @returns {string|*}
 */
export function licencePlateFormat(source) {
  if (!(/^[\u4e00-\u9fff]/.test(source))) {
    return source
  }
  if (source !== '无牌') {
    return source.slice(0, 2) + ' <i class="dot"></i> ' + source.slice(2)
  }
  return source
}

/**
 * 获取当前时间天的时间戳 - 2022-04-14 00:00:00
 * @returns {number}
 */
export function numberToChinese(number) {
  var chineseNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var chineseUnit = ['', '十', '百', '千']

  // 定义递归转换函数
  function convert(num) {
    var result = ''

    // 将数字转换成字符串并拆分成数组
    var numStr = num.toString()
    var numArr = numStr.split('')

    // 遍历数字数组
    for (var i = 0; i < numArr.length; i++) {
      var digit = parseInt(numArr[i])

      // 判断是否是零位
      var isZero = (digit === 0)

      // 判断是否需要添加单位
      var needUnit = (numArr.length > 1) && (digit !== 0) && (i !== numArr.length - 1)

      // 将数字转换成中文并拼接到结果字符串
      if (!isZero) {
        result += chineseNum[digit]
      }

      if (needUnit) {
        result += chineseUnit[numArr.length - i - 2]
      }
    }

    return result
  }

  var digitArr = [] // 定义一个数组存储每四位的数字
  var result = ''

  // 将数字按四位一组进行划分
  while (number > 0) {
    digitArr.push(number % 10000)
    number = Math.floor(number / 10000)
  }

  // 对每四位的数字进行转换
  for (var i = digitArr.length - 1; i >= 0; i--) {
    var digit = digitArr[i]

    if (digit !== 0) {
      result += convert(digit) + chineseUnit[i * 4]
    } else {
      result += convert(digit)
    }
  }

  return result
}

/**
 * 输入框内容格式化
 */
export function amountFormat(obj, param, value, flag) {
  if(flag){
    obj[param] = value.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1')
  }else{
    obj[param] = value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
  }
}
export function numberFormat(obj, param, value) {
  obj[param] = value.replace(/[^\d]/g, '')
}
export function spaceFormat(obj, param, value) {
  obj[param] = value.replace(/\s/g, '')
}
export function plateFormat(obj, param, value) {
  if(param){
    obj[param] = value.replace(/\s/g, '').toUpperCase();
  }else{
    obj = value.replace(/\s/g, '').toUpperCase();
  }
  
}


/**
 * 清除对象中的空参
 */
export function removeEmptyProperties(obj) {
  Object.keys(obj).forEach(function(key) {
      if (obj[key] === '' || obj[key] === ' ' || obj[key] === null || obj[key] === undefined) {
          delete obj[key];
      }
  })
}


export function timeDifference (time1, time2) {

  // 1. 创建两个moment对象
  let start = new Date(time1).getTime();
  let end = new Date(time2).getTime();
  
  // 2. 计算总秒数
  let diffSeconds = parseInt((end-start)/1000);
  
  // 3. 计算天、时、分、秒
  let days = Math.floor(diffSeconds / (24 * 3600));
  let remainSeconds = diffSeconds % (24 * 3600);
  let hours = Math.floor(remainSeconds / 3600);
  remainSeconds = remainSeconds % 3600;
  let minutes = Math.floor(remainSeconds / 60);
  let seconds = remainSeconds % 60;
  let time = ''
  if(days>0){
    time = time + days+'天';
  }
  if(hours>0 || time){
    time = time + hours+'时';
  }
  if(minutes>0 || time){
    time = time + minutes+'分';
  }
  if(seconds>0 || time){
    time = time + seconds+'天';
  }
  console.log(11111111111111111111111)
  console.log(time)
  return time;
// 输出：相差：3天 3时 30分 45秒
}